import React, { Component } from 'react'
import _, { flatten, noop, uniqBy } from 'lodash'
import UserAPI from 'restAPI/UserAPI';
import { isHistory, EVENTS_MAP, RenderChangeText } from './FindingHistory';
import { Alert, Avatar, Col, Row, Spin, Switch, Tabs, Tooltip, Typography } from 'antd';
import { InfoIcon, LoadingIcon } from 'components/Icons';
import MessageEditor from 'components/MessageEditor';
import { CellRenderers } from 'utils/tableUtils';
import { BASE_PADDING } from 'constants/Layout';
import { withActiveUser } from 'contexts/ActiveUserContext';
import FileUploadWidget from 'components/FileUploadWidget';
import FindingAPI from 'restAPI/FindingAPI';
import { MarkdownFormatter } from 'components/MarkupFormatter';
import { transformComment } from 'utils/commentUtil';
import CommentComponent from 'components/CommentComponent';
import axios from 'axios';
import { removeNonPrintableUnicodeCharacters } from 'utils/fileUtils';
import parseHtml from 'utils/parserUtil';
import { getVocabulary } from 'components/Vocabulary';
import classNames from 'classnames';
import GlobalSettingAPI from 'restAPI/GlobalSettingAPI';
import ACButton from 'ac-components/ac-button/ACButton';
import ExternalIcon from 'ac-components/ac-icons/ExternalIcon';
import ACLink from 'ac-components/ACLink/ACLink';

const { Text } = Typography;

export const TOOLS_COMMENTS_CONFIG = {
    checkmarx: {
        apiToolName: 'CHECKMARX',
        tabDisplayName: 'Checkmarx'
    },
    hackerone: {
        apiToolName: 'HACKERONE',
        tabDisplayName: 'HackerOne',
        errorAlertMessage: 'Only Available for Pull based HackerOne integration.',
    },
    fortify :{
        apiToolName: 'FORTIFY',
        tabDisplayName: 'Fortify',
        errorAlertMessage: 'Only Available for Pull based Fortify integration.',
    },
    "github code scan":{
        apiToolName: 'GITHUB CODE SCAN',
        tabDisplayName: 'GitHub Code Scan',
    },
    "github secret scan":{
        apiToolName: 'GITHUB SECRET SCAN',
        tabDisplayName: 'GitHub Secret Scan',
    },
    "dependabot":{
        apiToolName: 'DEPENDABOT',
        tabDisplayName: 'GitHub Dependabot',
    },
    "blackduck hub": {
        apiToolName: 'Blackduck Hub',
        tabDisplayName: 'Blackduck Hub'
    },
    "appcheck": {
        apiToolName: 'APPCHECK',
        tabDisplayName: 'AppCheck'
    },
    "veracode": {
        apiToolName: 'VERACODE',
        tabDisplayName: 'Veracode'
    },
    "checkmarx one": {
        apiToolName: 'CHECKMARX ONE',
        tabDisplayName: 'Checkmarx One'
    },
    netsparker: {
        apiToolName: 'NETSPARKER',
        tabDisplayName: 'Netsparker'
    },
    "contrast security": {
        apiToolName: 'CONTRAST SECURITY',
        tabDisplayName: 'Contrast Security'
    },
    "wiz":{
        apiToolName: 'WIZ',
        tabDisplayName: 'Wiz'
    },
    "iriusrisk" :{
        apiToolName: "IRIUSRISK",
        tabDisplayName:"IriusRisk"
    },
    "traceable" :{
        apiToolName: "TRACEABLE",
        tabDisplayName:"Traceable"
    }
}
export class FindingHistoryV2 extends Component {
    static defaultProps = {
        title: "Comments"
    }
    listRef = React.createRef()
    state = {
        loading: true,
        users: [],
        events: [],
        comments: [],
        history: [],
        toolsComments: [],
        toolsCommentsError: false,
        otherVersionIds: [],
        otherVersionFindings: [],
        showOtherVersionComments: false,
        activeTab: 'collaboration',
        ticketComments: false,
        showTicketComments: true,
        eventPage: 0,
        hasMoreEvents: false,
        loadingMoreEvents: false
    }
    constructor(props) {
        super(props);
        _.bindAll(
            this,
            "fetchVersionIds",
            "toggleVersionedComments",
            "setActiveTab",
            "onSend",
            "loadMoreEvents",
        );
    }
    async componentDidMount() {
        await this.fetchTicketSettings();
        this.fetchVersionIds();
        this.fetchUsers();
        this.setRef();
    }
    componentDidUpdate(prevProps) {
        if (this.props.finding?.id !== prevProps.finding?.id && this.props.finding?.id) {
            this.setState({
                events: [],
                comments: [],
                history: []
            });
            this.fetchVersionIds();
            this.fetchUsers();
        }
    }
    setRef() {
        const refObj = {
            refresh: this.fetchVersionIds
        }
        const { ref } = this.props;
        if (ref) {
            if (_.isFunction(ref)) {
                ref(refObj);
            } else if (ref.current) {
                ref.current = refObj;
            }
        }
    }
    async fetchUsers() {
        const { finding } = this.props;
        if (!finding?.product?.id) {
            return;
        }
        try {
            const { promise, cancel } = UserAPI.getAll(finding.product.id);
            this.cancelAPI2 = cancel;
            const users = await promise;
            this.setState({
                users
            });
        } catch (e) {
            console.log(e);
        }
    }

    async fetchTicketSettings(){
        try {
            const { promise, cancel } = GlobalSettingAPI.getCustomizedTicketSetting();
            this.cancelAPI2 = cancel;
            const data = await promise;
            const isTicketCommentsAllowed = !_.isNil(data.allowTicketCommentsInFindings) ? data.allowTicketCommentsInFindings : false 
            this.setState({ticketComments: isTicketCommentsAllowed});
        } catch (e) {
            console.log(e);
        }
    }

    toggleVersionedComments(){
        this.setState({
            showOtherVersionComments: !this.state.showOtherVersionComments,
            loading: true,
        }, this.fetchVersionIds)
    }

    fetchNextversionBatch(page = 0, totalPages, cb = noop){
        const { finding } = this.props;
        const totalRequestsToBeMade = page === 0 ? 1 : totalPages - 1;
        const promises = [];
        for(let i = 0; i < totalRequestsToBeMade; i++){
            promises.push(
              FindingAPI.getAll({
                page: page + i,
                size: 20,
                filters: {
                  versionId: [finding.id],
                },
              }).promise
            );
        }
        Promise.all(promises).then(responses => {
            const allFindings = flatten(responses.map(r => r.content));
            this.setState(prev => ({
                otherVersionFindings: [...prev.otherVersionFindings, ...allFindings]
            }), () => {
                if(page === 0){
                    this.fetchNextversionBatch(page + 1, responses[0].totalPages, cb)
                } else {
                    cb();
                }
            })
        });
    }

    fetchVersionIds(){
        const {featureFlags, finding} = this.props;
        console.log(finding)
        if(!finding?.id){
            return;
        }
        if(featureFlags.VERSIONS && this.state.showOtherVersionComments){
            this.fetchNextversionBatch(0, undefined, () => {
                this.fetchEvents();
            })
        } else {
            this.fetchEvents();
        }
    }

    getToolsConfigKey = () => {
        return getToolsConfigKey(this.props);
    }

    getToolsComments = async (params) => {
        const { toolsComments: initialValue} = this.state;
        let toolsCommentsError = false;
        let toolsComments = initialValue;
        try{
            const toolName = this.getToolsConfigKey();
            const {
                [toolName]: {
                    apiToolName
                } = {}
            } = TOOLS_COMMENTS_CONFIG;
            const isToolsCommentsEnabled = this.shouldRenderToolsComments(toolName);
            if(!apiToolName || isToolsCommentsEnabled === false){
                return;
            }
            const commentsData = await FindingAPI.getToolsComments(apiToolName,params).promise;
            if(commentsData && commentsData.content){
                toolsComments = commentsData.content.sort((a, b) => a.createdAt - b.createdAt);
            }
        }catch(err){
            toolsCommentsError = true;
            console.error('Error in loadHistory:', err);
        }
        this.setState({
            toolsCommentsError,
            toolsComments,
        });
    }

    async fetchEvents(pageNum = 0, append = false, cb = _.noop) {
        const { finding, getHistory, getComment } = this.props;
        const { showOtherVersionComments } = this.state;
        if (!finding?.id) {
            return;
        }

        const { id, toolId, product: { id: productId }, appId: subProductId, envName: environment, additionalDetails: { repositoryName }, toolName } = finding;
        try {
            const { promise: promise1, cancel: cancel1 } = getHistory(id, { page: pageNum, size: 10 });
            const findings = uniqBy([finding, ...(showOtherVersionComments ? this.state.otherVersionFindings : [])], "id");
            const findingIdsForComment = findings.map(f => f.id);
            const commentRequests = findingIdsForComment.map((id) => getComment(id, ...(this.state.ticketComments ? [{listTicketComments: true}] : [{}])));
            this.getToolsComments({findingId: id, id: toolId , productId, subProductId, environment, ...(((toolName === 'Github Code Scan' || toolName === "Github Secret Scan" || toolName === "Dependabot" || toolName === "Traceable") && repositoryName ) ?  { repositoryName }: {}) });
            Promise.all([promise1, ...commentRequests.map(c => c.promise)]).then(([history, ...commentsResponse]) => {
                const allComments = flatten(commentsResponse.map((response, i) => response.content.map(comment => {
                    comment.finding = findings[i];
                    return comment;
                })));

                const newHistory = [...(_.filter(history.content, item => EVENTS_MAP[item.event]) || []).sort((a, b) => a.createdAt - b.createdAt)];
                const filteredHistory = newHistory.filter((e) => {
                    if (e.event === 'OTHER_PROPERTIES') {
                        try {
                            JSON.parse(e.eventOldData);
                            JSON.parse(e.eventNewData);
                            return true;
                        } catch(error) {
                            return false;
                        }
                    }
                    return true;
                });

                if (append) {
                    // Use functional setState to ensure we're appending to the latest state
                    this.setState(prevState => ({
                        loading: false,
                        history: [...prevState.history, ...filteredHistory],
                        comments: allComments.sort((a, b) => a.createdAt - b.createdAt),
                        eventPage: pageNum,
                        hasMoreEvents: !history.last,
                        loadingMoreEvents: false
                    }));
                } else {
                    this.setState({
                        loading: false,
                        history: filteredHistory,
                        comments: allComments.sort((a, b) => a.createdAt - b.createdAt),
                        eventPage: pageNum,
                        hasMoreEvents: !history.last,
                        loadingMoreEvents: false
                    });
                }
                cb();
            }, console.error)
            return ()=>{
                cancel1();
                commentRequests.forEach(c => c.cancel());
            }
        } catch (e) {
            console.log(e);
        }
    }

    loadMoreEvents() {
        const { hasMoreEvents, eventPage, loadingMoreEvents } = this.state;

        if (loadingMoreEvents || !hasMoreEvents) {
            return;
        }

        this.setState({ loadingMoreEvents: true });
        const nextPage = eventPage + 1;

        this.fetchEvents(nextPage, true);
    }

    setActiveTab(e) {
        this.setState({
            activeTab: e
        });
        this.fetchVersionIds();
    }

    getToolEvent(event) {
        switch (event.type) {
            case 'activity-bug-resolved':
                return <>Changed the status to <b>Resolved</b>.</>;
            case 'activity-bug-triaged':
                return <>Changed the status to <b>Triaged</b>.</>;
            default:
                return undefined;
        }
    }

    SaveCommentDirectly(response) {
        const {comment, attachments = [], id} = response;
        const { activeUser, finding } = this.props;
        const comments = _.cloneDeep(this.state.comments);
        const index = _.findIndex(comments, (c) => c.id === id);
        if (index !== -1) {
            comments[index] = {
                ...response,
                finding
            };
        } else {
            const commentObject = {
                id,
                note: comment,
                createdAt: Date.now(),
                createdBy: activeUser.email,
                attachments,
                finding,
            }
            comments.push(commentObject);
        }
        this.setState({ comments });
    }
    async onSend({ htmlText: comment, markdownText, mentionUserIds, attachments, commentId }) {
        const { postComment, finding: { id } } = this.props;
        if (comment || attachments) {
            const payload = { htmlText: comment, markdownText, userIds: mentionUserIds, attachments: _.map(attachments, doc => doc.id), commentId};
            const response = await postComment(id, payload).promise;
            this.SaveCommentDirectly(response);
        }
    }
    getItemDataProps({item, toolComment}) {
        const {finding: { id, toolName } } = this.props;
        const { users } = this.state;
        const user = _.find(users, { email: item.createdBy }) || {};
        const userName = user.displayName || item.createdBy || "";
        const matches = userName.match(/\b(\w)/g);
        let note = item.note || item.comment || item.message || "";
        let reason;
        if (item.acceptRiskReason !== 'Rejected' && item.controlledReason !== 'Rejected' && item.event !== EVENTS_MAP.PROPOSE_ACCEPTRISK && item.event !== EVENTS_MAP.PROPOSE_CONTROLLED) {
            reason = item.acceptRiskReason || item.controlledReason;
        }
        const toolStatus = toolComment ? this.getToolEvent(item) : undefined;

        let unsupresTime;

        if (note.indexOf('Resurface date as') !== -1) {
            const splittedString = _.split(note, "Resurface date as");
            note = splittedString[0].trim() === "null" ? CellRenderers.VALUE_OR_NA() : splittedString[0];
            unsupresTime = _.split(splittedString[1], "{").pop().split("}").shift();
        }

        let noteContent;
        if (toolComment || item.isTicketComment) {
            noteContent = <MarkdownFormatter markdown={note} />
        } else if (isHistory(item)) {
            noteContent = note;
        } else {
            noteContent = parseHtml(note, {
                transform: (reactNode, node, index) =>  transformComment(reactNode, node, index, users)
            });
        }

        let content = noteContent;
        if(toolStatus) {  //checks the event type
            content = (
                <>
                    {toolStatus}
                    <br />
                    {CellRenderers.VALUE_OR_NA(content)}
                </>
            )
        }

        const showNote =  [EVENTS_MAP.ATTACHMENT_UPDATED, EVENTS_MAP.TRIAGE_INFO_UPDATE, EVENTS_MAP.DELETE_CORRELATED_FINDING, EVENTS_MAP.FINDING_CREATED, EVENTS_MAP.SLA_RECALCULATION, EVENTS_MAP.SLA_RECOVERY].indexOf(item.event) === -1;
        if (isHistory(item)) {
            content = (
                <>
                    <RenderChangeText event={item} />
                    {
                        showNote && <>
                            <br />
                            <Text strong>Note:</Text> {content ? parseHtml(content) : CellRenderers.VALUE_OR_NA()}
                        </>
                    }
                    {reason ? <><br /><Text strong>Reason:</Text> {CellRenderers.VALUE_OR_NA(reason)}</> : null}
                    {
                        unsupresTime 
                        ?
                        <>
                        <br/>
                            <><Text strong>Resurface Date:</Text> </>{CellRenderers.DATE(unsupresTime)}
                        </>
                        :
                        null
                    }
                </>
            )
        }
        // This is for old format where we upload the attachment along with the comment 
        if (!_.isEmpty(item.attachments)) {
            content = (
                <>
                    {noteContent}
                    {
                     < div className="d-flex flex-wrap">
                        {
                            item.attachments.map(file => {
                                if(toolComment) {
                                    return file.fileName && <a key={file.fileName} className="amc-preview-link m-r-xs" rel="noopener noreferrer" target="_blank" href={file.url}><FileUploadWidget file={file} /></a>
                                } else {
                                    return file.name && <a key={file.id} className="amc-preview-link m-r-xs" rel="noopener noreferrer" target="_blank" href={`/user/findings/${id}/attachment/${file.id}`}><FileUploadWidget file={file} /></a>
                                }
                            })
                        }
                    </div>
                    }
                </>
            )
        }
        return {
            author: (toolComment ?
                <><a rel="noopener noreferrer" target="_blank" href={item.profileUrl}><Typography.Link>{userName}</Typography.Link></a>{!_.isEmpty(item.bio) ? <Tooltip title={item.bio}><InfoIcon className="m-l-xs"/></Tooltip> : ''}</>
                : userName),
            avatar: <Avatar size="small">{matches?.join("") || userName[0]}</Avatar>,
            content,
            datetime: ( toolName === "Blackduck Hub" && item.updatedAt
                ?
                <>
                Created At : <Tooltip title={CellRenderers.TIME_RELATIVE(item.createdAt)} placement="right">
                    {CellRenderers.TIME(item.createdAt)}
                </Tooltip>
                &nbsp; Updated At : <Tooltip title={CellRenderers.TIME_RELATIVE(item.updatedAt)} placement="right">
                    {CellRenderers.TIME(item.updatedAt)}
                </Tooltip>
                </>
                :
                <Tooltip title={CellRenderers.TIME_RELATIVE(item.createdAt)} placement="right">
                    {CellRenderers.TIME(item.createdAt)}
                </Tooltip>
            )
        }
    }

    renderEventsList(list, showMessageBox, isToolsComment) {
        const toolsConfigKey = this.getToolsConfigKey();
        const getErrorAlertMessage = () => {
            const {
                [toolsConfigKey]: {
                    errorAlertMessage
                } = {}
            } = TOOLS_COMMENTS_CONFIG;
            if(!isToolsComment 
                || !this.state.toolsCommentsError 
                || typeof errorAlertMessage !== 'string'){
                    return null;
            }
            return(
                <Col span={24}><Alert type="warning" message={errorAlertMessage} /></Col>
            )
        }
        const toolsAlertMessage = getErrorAlertMessage();
        return (
            <Row ref={this.listRef}>
                {
                    _.isEmpty(list)
                        ?
                        <>
                            {toolsAlertMessage}
                            <Col span={24}>{showMessageBox ? <div className="text-center p-l">No comments</div> : <div className="text-center p-l">No events</div>}</Col>
                        </>
                        : <CommentComponent
                            state={this.state}
                            {...this.props}
                            commentList={list}
                            showEditButton={showMessageBox}
                            onCommentSubmit={this.onSend}
                            getItemDataProps={item => this.getItemDataProps({item, toolComment: isToolsComment})}
                            colWrap
                            attachmentV2Handler={this.uploadFileForEditor}
                            canEdit={item => item.finding?.id === this.props.finding?.id}
                            renderExtraMeta={
                                this.state.activeTab === 'collaboration' ?
                                (item) => <>
                                    {
                                        this.state.showOtherVersionComments &&
                                        <Tooltip
                                            title={`${getVocabulary("subProduct")} version`}
                                        >
                                            <span className="m-l-xs">
                                            ({item.finding?.subProductVersion})
                                            </span>
                                        </Tooltip>
                                            
                                    }
                                    {
                                        item.isTicketComment && (
                                            <a
                                                href={item.ticketLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="m-l-sm"
                                            >
                                                <ACButton size="sm" type="secondary">
                                                <span className="d-flex align-items-center">
                                                    {item.ticketId}
                                                    <ExternalIcon className="p-l-sm" />
                                                </span>
                                                </ACButton>
                                            </a>
                                        )
                                    }

                                </>
                                :
                                null
                              }
                        />
                }
                {
                    showMessageBox
                        ?
                        <Col span={24}>
                            <MessageEditor 
                                onSubmit={this.onSend} 
                                users={this.state.users} 
                                findingId={this.props.finding?.id} 
                                maxFileSize={50} 
                                attachmentV2Handler={this.uploadFileForEditor}
                                hideOldUpload
                            />
                        </Col>
                        :
                        null
                }
            </Row>
        )
    }

    uploadFileForEditor = async (file) => {
        if (file) {
            const fileName = removeNonPrintableUnicodeCharacters(file.name);
            const { id, signedUrl } = await FindingAPI.uploadManualAttachment({ fileName }).promise;
            await axios({ method: 'put', url: signedUrl, data: file });
            const params = new URLSearchParams({attachmentId: id, filename: fileName});
            const url = `/user/tools/generic/CUSTOM/attachment?${params.toString()}`;
            return url;
        }
    }

    shouldRenderToolsComments = (toolsConfigKey) => {
        const { featureFlags } = this.props;
        const FEATURE_FLAG_NOT_CONFIGURED = 'FEATURE_FLAG_NOT_CONFIGURED';
        if(typeof toolsConfigKey !== 'string' || !TOOLS_COMMENTS_CONFIG[toolsConfigKey]){
            return false;
        }
        const {
            [toolsConfigKey]: {
                featureFlagKey = FEATURE_FLAG_NOT_CONFIGURED
            }
        } = TOOLS_COMMENTS_CONFIG;
        return !!(featureFlagKey === FEATURE_FLAG_NOT_CONFIGURED || featureFlags[featureFlagKey] === true);
    }
    renderCommentsContent(){
        const { loading, comments, showOtherVersionComments, showTicketComments } = this.state;
        const { featureFlags, finding } = this.props;
        const disabledVersionedComments = !(featureFlags.VERSIONS && (finding?.productVersion || finding?.subProductVersion));
        let filteredCommentList = comments;
        if(!showTicketComments){
            filteredCommentList = _.filter(comments, (comment) => !comment.isTicketComment); 
        }
        return (
            <>
                {featureFlags.VERSIONS && (
                    <span
                        className={classNames({
                            clickable: !disabledVersionedComments,
                        })}
                        onClick={
                            disabledVersionedComments
                                ? noop
                                : this.toggleVersionedComments
                        }
                    >
                        <Switch
                            disabled={disabledVersionedComments}
                            size="small"
                            checked={showOtherVersionComments}
                            className="m-r-xs"
                        />{" "}
                        Show comments from all versions
                    </span>
                )}
                {this.state.ticketComments && (
                    <div className='m-y-xs'>
                        <Switch
                        size="small"
                        checked={this.state.showTicketComments}
                        onChange={(checked) => this.setState({showTicketComments: checked})}
                        className="m-r-xs"
                        />
                        Show Ticket comments
                    </div>
                )}
                <div>
                    <Spin spinning={loading} indicator={<LoadingIcon />}>
                        {this.renderEventsList(filteredCommentList, true)}
                    </Spin>
                </div>
            </>
        );
    }
    renderHistoryContent(){
        const { loading, history, hasMoreEvents, loadingMoreEvents } = this.state;

        return (
          <div>
            <Spin spinning={loading} indicator={<LoadingIcon />}>
              {this.renderEventsList(history)}
            </Spin>
            {(loadingMoreEvents || hasMoreEvents) && (
              <div className="text-center m-t-m">
                {loadingMoreEvents ? (
                  <div
                    role="status"
                    aria-live="polite"
                    aria-label="Loading more events"
                  >
                    <LoadingIcon className="font-size-24" />
                    <span className="sr-only">Loading more events...</span>
                  </div>
                ) : (
                  <ACLink
                    onClick={this.loadMoreEvents}
                    role="button"
                    aria-label="Load more events"
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.loadMoreEvents();
                      }
                    }}
                  >
                    Load More
                  </ACLink>
                )}
              </div>
            )}
          </div>
        );
    }
    renderToolComments(){
        const { loading, toolsComments } = this.state;
        return (
            <div style={{ padding: `${BASE_PADDING}px ${2 * BASE_PADDING}px` }}>
                <Spin spinning={loading} indicator={<LoadingIcon />}>
                    {this.renderEventsList(toolsComments, false, true)}
                </Spin>
            </div>
        );
    }
    render() {
        const { title, fixedContent } = this.props;
        const toolsConfigKey = this.getToolsConfigKey();
        const {
            [toolsConfigKey]: {
                tabDisplayName,
            } = {}
        } = TOOLS_COMMENTS_CONFIG;
        
        if(fixedContent === "comments"){
            return this.renderCommentsContent();
        } else if(fixedContent === "history"){
            return this.renderHistoryContent();
        } else if(fixedContent === "toolComments"){
            return this.renderToolComments();
        }
        return (
            <Tabs destroyInactiveTabPane className={'message-editor-overflow-show finding-detail-info finding-comment-section'} size="small" defaultActiveKey="collaboration" animated={false} onChange={this.setActiveTab}>
                <Tabs.TabPane tab={title} key="collaboration">
                    {this.renderCommentsContent()}
                </Tabs.TabPane>
                {
                    <Tabs.TabPane tab="History" key="history">
                        {this.renderHistoryContent()}
                    </Tabs.TabPane>
                }
                {
                    this.props.attachmentsRender
                    ?
                    <Tabs.TabPane tab="Attachments" key="Attachments">
                        {this.props.attachmentsRender()}
                    </Tabs.TabPane>
                    :
                    null
                }
                {
                    this.shouldRenderToolsComments(toolsConfigKey) && 
                    <Tabs.TabPane tab={tabDisplayName} key={toolsConfigKey}>
                        {this.renderToolComments()}
                    </Tabs.TabPane>
                }
            </Tabs>
        )
    }
}

export default withActiveUser(FindingHistoryV2);

const getToolsConfigKey = (props) => {
    let toolsConfigKey;
    const { 
        finding : {
            source: {
                name: tool
            } = {}
        } = {}
    } = props;
    if(typeof tool === 'string'){
        toolsConfigKey = tool.toLowerCase().trim();
    }
    return toolsConfigKey;
}

export const getToolCommentsTabDisplayName = (finding) => {
    const toolsConfigKey = getToolsConfigKey({finding});
    const {
        [toolsConfigKey]: {
            tabDisplayName,
        } = {}
    } = TOOLS_COMMENTS_CONFIG;
    return tabDisplayName;
}

export const shouldRenderToolsComments = (finding, featureFlags) => {
    const toolsConfigKey = getToolsConfigKey({finding});
    const FEATURE_FLAG_NOT_CONFIGURED = 'FEATURE_FLAG_NOT_CONFIGURED';
    if(typeof toolsConfigKey !== 'string' || !TOOLS_COMMENTS_CONFIG[toolsConfigKey]){
        return false;
    }
    const {
        [toolsConfigKey]: {
            featureFlagKey = FEATURE_FLAG_NOT_CONFIGURED
        }
    } = TOOLS_COMMENTS_CONFIG;
    return !!(featureFlagKey === FEATURE_FLAG_NOT_CONFIGURED || featureFlags[featureFlagKey] === true);
}